import { render, staticRenderFns } from "./link.vue?vue&type=template&id=1d3cc8e2"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3cc8e2')) {
      api.createRecord('1d3cc8e2', component.options)
    } else {
      api.reload('1d3cc8e2', component.options)
    }
    module.hot.accept("./link.vue?vue&type=template&id=1d3cc8e2", function () {
      api.rerender('1d3cc8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/link.vue"
export default component.exports